import { PopupOverlay, PopupContent, CloseButton, Title, Description, Button } from "./WelcomePopup.styles";

type WelcomePopupProps = {
  onClose: () => void;
};

export const WelcomePopup = ({ onClose }: WelcomePopupProps) => {
  return (
    <PopupOverlay>
      <PopupContent>
        <CloseButton onClick={onClose} />
        <Title>FAMILIE-TIJD!</Title>
        <Description>
          Welkom bij Family Mode! Maak nu je familie na om deze in de games te gebruiken!
          En wil je later nog iets aanpassen? Dat kan altijd.
        </Description>
        <Button onClick={onClose}>OKAY!</Button>
      </PopupContent>
    </PopupOverlay>
  );
};
